import React, { Component } from 'react'
import { Alert, Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Paper, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material'
import { GridTable } from '../../Sidebar/SidebarStyles'
import { getbroker } from '../../ApiSevices/UserMasterApis';
import { addorUpdateQuoteQuestionConfig, deleteQuoteQuestionConfig, editQuoteQuestionConfig, getAllCoverageSpecification, getAllLobMaster, getAllQuestionConfig, getAllQuestionsMaster } from '../../ApiSevices/QuoteCompareAPI';
import { Delete, Edit } from '@mui/icons-material';
import { GridColDef } from '@mui/x-data-grid';
import ConfirmationDialogComponent from '../../Common/ConfirmationDialogComponent';
import { baseUrl, decodeJwt } from '../ApiCommonService';
import { expTokenProcessAndGenerate } from '../../ApiSevices/AuthApis';

interface IProps {
    displaysidebar: boolean;
}

interface IState {
    loading: boolean;
    SelectedLob: number;
    SelectedQuestionConfig: number;
    SelectedCoverageSpec: number;
    SelectedBrokerId: number;
    brokerMaster: any[];
    LobMaster: any[];
    CoverageMaster: any[];
    QuestionMaster: any[];
    questionConfigData: any[];
    confirmationDialog: {
        isOpen: boolean,
        recordId: number,
        message: string,
        activate: boolean,
        isDelete?: boolean
    },
    addDialogData: {
        selectedLob: number;
        selectedQuestionConfig: number;
        selectedBrokerId: number;
        selectedCoverageSpec: number;
        isOpen: boolean;
        row: any
    },
    snackbarOpen: boolean;
    snackbarMessage: string;
    snackbarSeverity: 'success' | 'error' | 'info' | 'warning';
}

const columns: GridColDef[] = [
    { field: 'LobQuestionID', headerName: 'Id', width: 70 },
    { field: 'LOB', headerName: 'LOB', width: 200 },
    { field: 'Question', headerName: 'Question', width: 200 },
    { field: 'CoverageSpecification', headerName: 'Coverage Specification', width: 200 },
    { field: 'SortOrder', headerName: 'SortOrder', width: 100 },
    { field: 'Action', headerName: 'Action', width: 100 }
];

export default class QcQuestionConfig extends Component<IProps, IState> {

    constructor(props: IProps) {
        super(props)
        this.state = {
            loading: false,
            SelectedCoverageSpec: 0,
            SelectedLob: 0,
            SelectedQuestionConfig: 0,
            SelectedBrokerId: 0,
            brokerMaster: [],
            LobMaster: [],
            CoverageMaster: [],
            QuestionMaster: [],
            questionConfigData: [],
            confirmationDialog: {
                isOpen: false,
                recordId: 0,
                message: "",
                activate: false
            },
            addDialogData: {
                selectedLob: 0,
                selectedBrokerId: 0,
                selectedCoverageSpec: 0,
                selectedQuestionConfig: 0,
                isOpen: false,
                row: null
            },
            snackbarMessage: "",
            snackbarOpen: false,
            snackbarSeverity: "info"
        }
    }

    componentDidMount(): void {
        this.updateBrokerList();
    }

    async updateBrokerList() {
        this.setState({ loading: true });
        try {
            const [brokerResponse] = await Promise.all([
                getbroker()
            ]);
            let sortStaticArry = brokerResponse?.sort((a: any, b: any) => a?.vchBrokerName.localeCompare(b?.vchBrokerName))
            let brokerMasterAltered = sortStaticArry?.map((e: any) => { return { label: e?.vchBrokerName, value: e?.Broker_ID } });
            brokerMasterAltered = brokerMasterAltered?.filter((f: any) => f?.value !== 0)

            this.setState({ brokerMaster: brokerMasterAltered });
        } catch (error) {
            console.error("Error updateing BrokerMaster", error);
        } finally {
            this.setState({ loading: false });
        }
    }

    async updateMasterData() {
        this.setState({ loading: true });
        try {
            const { SelectedBrokerId } = this.state;
            this.setState({ LobMaster: [], CoverageMaster: [], QuestionMaster: [], questionConfigData: [], SelectedCoverageSpec: 0, SelectedLob: 0, SelectedQuestionConfig: 0 });
            if (!SelectedBrokerId) {
                return
            }

            const [questionResponse, coverageResponse, lobResponse] = await Promise.all([
                getAllQuestionsMaster(SelectedBrokerId),
                getAllCoverageSpecification(SelectedBrokerId),
                getAllLobMaster(SelectedBrokerId)
            ]);

            let sortQuestionStaticArry = questionResponse?.filter((e: any) => e.QuestionCode !== "PT2")?.sort((a: any, b: any) => Number(b?.IsCommon) - Number(a?.IsCommon))?.sort((a: any, b: any) => {
                if (a.QuestionCode === "PT1") return 1;
                if (b.QuestionCode === "PT1") return -1;
                return 0;
            });
            let questionArray = sortQuestionStaticArry?.map((e: any) => { return { label: e?.Question, value: e?.QuestionID } });
            questionArray = questionArray?.filter((f: any) => f?.value !== 0)

            let sortCoverageStaticArry = coverageResponse?.sort((a: any, b: any) => a?.CoverageSpecification?.localeCompare(b?.CoverageSpecification))
            let coverageArray = sortCoverageStaticArry?.map((e: any) => { return { label: e?.CoverageSpecification, value: e?.CoverageSpecID } });
            coverageArray = coverageArray?.filter((f: any) => f?.value !== 0)

            let sortLobStaticArry = lobResponse?.sort((a: any, b: any) => a?.LobDescription?.localeCompare(b?.LobDescription))
            let lobArray = sortLobStaticArry?.map((e: any) => { return { label: e?.LobDescription, value: e?.ID, LobDescription: e.LobDescription } });
            lobArray = lobArray?.filter((f: any) => f?.value !== 0)

            this.setState({ LobMaster: lobArray, CoverageMaster: coverageArray, QuestionMaster: questionArray });
        } catch (error) {
            console.error("Error Updating Master data", error);
        } finally {
            this.setState({ loading: false });
        }
    }

    async onSearchClick() {
        this.setState({ loading: true, questionConfigData: [] });
        try {
            const { SelectedBrokerId, SelectedLob } = this.state;
            let response = await getAllQuestionConfig(SelectedBrokerId, SelectedLob);
            response = response.filter((e: any) => !e.Question.includes("PT2"))?.sort((a: any, b: any) => Number(b?.IsCommon) - Number(a?.IsCommon))?.sort((a: any, b: any) => {
                if (a.QuestionCode === "PT1") return 1;
                if (b.QuestionCode === "PT1") return -1;
                return 0;
            });
            this.setState({ questionConfigData: response });
        } catch (error) {
            console.error("Error fetching Data", error);
            this.setState({ questionConfigData: [] });
        } finally {
            this.setState({ loading: false });
        }
    }

    onAddClick() {
        try {
            this.setState((prevState: IState) => {
                return {
                    ...prevState, addDialogData: {
                        isOpen: true,
                        selectedBrokerId: prevState.SelectedBrokerId,
                        selectedCoverageSpec: prevState.SelectedCoverageSpec,
                        selectedLob: prevState.SelectedLob,
                        selectedQuestionConfig: prevState.SelectedQuestionConfig,
                        row: null
                    }
                };
            });
        } catch (error) {
            console.error(error);
        }
    }

    handleClose() {
        try {
            this.setState({
                addDialogData: {
                    isOpen: false,
                    selectedBrokerId: 0,
                    selectedCoverageSpec: 0,
                    selectedLob: 0,
                    selectedQuestionConfig: 0,
                    row: null
                }
            });
        } catch (error) {
            console.error(error);
        }
    }

    onConfirmationDialog = async (): Promise<void> => {
        this.setState({ loading: true });
        try {
            const { SelectedBrokerId } = this.state;
            if (this.state.confirmationDialog.isDelete) {
                const response = await deleteQuoteQuestionConfig(this.state.confirmationDialog.recordId, SelectedBrokerId);
                if (response) {
                    this.setState({
                        snackbarOpen: true, snackbarMessage: "Record Deleted", snackbarSeverity: "success",
                        confirmationDialog: {
                            isOpen: false,
                            recordId: 0,
                            message: '',
                            activate: false
                        }
                    });
                }
            }

            await this.onSearchClick();

        } catch (e) {
            console.error(e);
        }
        finally {
            this.setState({ loading: false });
        }
    }

    async onSubmit() {
        this.setState({ loading: true });
        try {
            const { addDialogData } = this.state;
            const { selectedBrokerId, selectedCoverageSpec, selectedLob, selectedQuestionConfig, row } = addDialogData;
            const body = {
                "LobID": selectedLob,
                "LobQuestionID": row?.LobQuestionID || 0,
                "QuestionCode": selectedQuestionConfig,
                "CoverageSpecCode": selectedCoverageSpec,
                "sorted_order": row?.SortOrder || 0,
                "CreatedOn": new Date()?.toISOString()
            };
            let response;
            if (body.LobQuestionID) {
                response = await editQuoteQuestionConfig(body, selectedBrokerId);
            } else {
                response = await addorUpdateQuoteQuestionConfig(body, selectedBrokerId);
            }
            if (response) {
                this.setState({
                    snackbarOpen: true, snackbarMessage: response.message, snackbarSeverity: response.status ? "success" : "error",
                    addDialogData: {
                        isOpen: false,
                        selectedBrokerId: 0,
                        selectedCoverageSpec: 0,
                        selectedLob: 0,
                        selectedQuestionConfig: 0,
                        row: null
                    }
                });
                this.onSearchClick();
            }

        } catch (error) {
            console.error(error);
        } finally {
            this.setState({ loading: false });
        }
    }

    handleCloseSnackbar = () => {
        this.setState({ snackbarOpen: false });
    };

    DownloadQuestionConfigFile = async () => {
        try {
            const { brokerMaster, LobMaster, SelectedBrokerId, SelectedLob } = this.state;
            const token = sessionStorage.getItem('token');
            const params = new URLSearchParams({});
            params.append("TenantId", String(SelectedBrokerId));
            params.append("LobId", String(SelectedLob));
            const url = `${baseUrl}api/QuoteCompare/downloadQuestionConfigData?${params.toString()}`;
            const Token = await expTokenProcessAndGenerate(token);
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'accept': 'application/json',
                    'Authorization': `Bearer ${Token}`
                }
            });
            if (response.ok) {
                const blob = await response.blob();
                const contentDisposition = response.headers.get('content-disposition');
                // const fileName = `${this.state.selectedJobForDownloadFiles?.JobCode}_discrepancy.xlsx`;
                const blobUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                const brokerName = brokerMaster.find(e => e.value === SelectedBrokerId).label;
                const lobName = LobMaster.find(e => e.value === SelectedLob).LobDescription;
                link.href = blobUrl;
                link.setAttribute('download', `${lobName}_Master_Data`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);
                // this.showSnackbar(`The selected ${getJobId}_discrepancy.xlsx downloaded successfully!`, 'success');
            } else {
                throw new Error('Failed to download file: ' + response.statusText);
            }
        } catch (error) {
            console.error('Error in downloading:', error);
            // this.showSnackbar("There is an error in downloading the file", 'error');
        }
    };

    render() {
        const {
            loading, SelectedLob, LobMaster, CoverageMaster, QuestionMaster, brokerMaster, SelectedBrokerId,
            questionConfigData, confirmationDialog, addDialogData, snackbarMessage, snackbarOpen, snackbarSeverity
        } = this.state;
        const token = sessionStorage.getItem('token');
        const decodedToken = decodeJwt(token);
        const userName = decodedToken?.userName || decodedToken?.Email;
        const showDelete = userName === "ramu_s@exdioninsurance.com" || userName === "Sanjay_joyit@exdioninsurance.com";
        return (
            <div style={{ fontSize: "12px" }}>
                {loading && (
                    <Box sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        zIndex: 9999
                    }}>
                        <div className="loader"></div>
                    </Box>
                )}
                <GridTable sx={{ height: '90vh' }} displaysidebar={this?.props?.displaysidebar}>
                    <div style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "20px",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        width: "100%",
                        paddingBottom: '15px'

                    }}>
                        {/* Broker id selection */}
                        <div style={{ flex: "1 1 150px", minWidth: "250px" }}>
                            <p style={{ margin: 0 }}><b>Select BrokerId</b></p>
                            <Autocomplete
                                options={brokerMaster}
                                getOptionLabel={(option) => option?.label || ''}
                                value={brokerMaster.find((e: any) => e.value === SelectedBrokerId) || null}
                                onChange={(event, newValue) => {
                                    this.setState({ SelectedBrokerId: newValue?.value || 0 }, () => this.updateMasterData());
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Select Broker..."
                                        size="medium"
                                        InputProps={{
                                            ...params.InputProps,
                                            style: { height: 25, fontSize: "11px" }
                                        }}
                                    />
                                )}
                                fullWidth
                                slotProps={{ listbox: { sx: { fontSize: '11px' } } }}
                            />
                        </div>

                        <div style={{ flex: "1 1 150px", minWidth: "250px" }}>
                            <p style={{ margin: 0 }}><b>Select Lob</b></p>
                            <Autocomplete
                                options={LobMaster}
                                getOptionLabel={(option) => option?.label || ''}
                                value={LobMaster.find((e: any) => e.value === SelectedLob) || null}
                                onChange={(event, newValue) => {
                                    this.setState({ SelectedLob: newValue?.value || 0 }, () => this.onSearchClick());
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Select Lob..."
                                        size="medium"
                                        InputProps={{
                                            ...params.InputProps,
                                            style: { height: 25, fontSize: "11px" }
                                        }}
                                    />
                                )}
                                fullWidth
                                slotProps={{ listbox: { sx: { fontSize: '11px' } } }}
                            />
                        </div>

                        {/* Search button */}
                        <div style={{ flex: "1 1 150px", minWidth: "150px", display: "flex", justifyContent: "flex-start", alignItems: "center", gap: '10px' }}>
                            <button
                                style={{
                                    height: "25px",
                                    padding: "0 20px",
                                    backgroundColor: "#1976d2",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    fontSize: "12px",
                                    marginTop: "15px",
                                    opacity: SelectedBrokerId && SelectedLob ? 1 : 0.5,
                                    pointerEvents: SelectedBrokerId && SelectedLob ? "auto" : "none"
                                }}
                                onClick={() => {
                                    this.onAddClick();
                                }}
                                disabled={!(SelectedBrokerId && SelectedLob)}
                            >
                                Add
                            </button>
                            <button
                                style={{
                                    height: "25px",
                                    padding: "0 20px",
                                    backgroundColor: "#1976d2",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    fontSize: "12px",
                                    marginTop: "15px",
                                    opacity: SelectedBrokerId && SelectedLob ? 1 : 0.5,
                                    pointerEvents: SelectedBrokerId && SelectedLob ? "auto" : "none"
                                }}
                                onClick={() => {
                                    this.DownloadQuestionConfigFile();
                                }}
                                disabled={!(SelectedBrokerId && SelectedLob)}
                            >
                                Export
                            </button>
                        </div>
                    </div>

                    <Paper sx={{ width: '100%', mb: 2, overflow: 'hidden', border: '0.5px solid #7a6e6e54' }}>
                        <Box sx={{ maxHeight: 400, overflowX: 'auto' }}>
                            <TableContainer sx={{ minWidth: 'max-content' }}> {/* Enable scrolling */}
                                <Table stickyHeader sx={{ height: '50px' }} size="small">
                                    {/* Table Header */}
                                    <TableHead>
                                        <TableRow>
                                            {columns.map((column) => (
                                                <TableCell
                                                    key={column.field}
                                                    sx={{
                                                        fontSize: '12px',
                                                        fontWeight: 'bold',
                                                        whiteSpace: 'nowrap',
                                                        backgroundColor: '#f5f5f5',
                                                        position: 'sticky',
                                                        top: 0,
                                                        zIndex: 1,
                                                        width: column.width,
                                                        minWidth: column.width,
                                                        maxWidth: column.width,
                                                    }}
                                                >
                                                    {column.headerName}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                </Table>
                                {/* Table Body */}
                                <Box sx={{ maxHeight: 310, overflowY: 'auto', overflowX: 'auto', scrollbarWidth: 'none', '&::-webkit-scrollbar': { display: 'none', }, }}>
                                    <Table size="small">
                                        <TableBody>
                                            {questionConfigData?.length === 0 ? (
                                                <TableRow>
                                                    <TableCell
                                                        colSpan={columns.length}
                                                        align="center"
                                                        sx={{
                                                            fontSize: "14px",
                                                            fontWeight: 500,
                                                            color: "gray",
                                                            padding: "20px",
                                                            borderBottom: "none",
                                                        }}
                                                    >
                                                        No records to display
                                                    </TableCell>
                                                </TableRow>
                                            ) : (
                                                questionConfigData?.map((row) => (
                                                    <TableRow key={row.Id}>
                                                        {columns.map((column) => (
                                                            <TableCell
                                                                key={column.field}
                                                                sx={{
                                                                    fontSize: "10px",
                                                                    whiteSpace: "normal",
                                                                    wordWrap: "break-word",
                                                                    lineHeight: "1.5",
                                                                    width: column.width,
                                                                    minWidth: column.width,
                                                                    maxWidth: column.width,
                                                                }}
                                                            >
                                                                {row?.isSelected &&
                                                                    column.field.toLowerCase() !== "id" &&
                                                                    column.field !== "QuestionCode" &&
                                                                    column.field !== "ChecklistLobCode" &&
                                                                    column.field !== "JobLobCode" &&
                                                                    column.field.toLowerCase() !== "isactive" &&
                                                                    column.field.toLowerCase() !== "action" ? (
                                                                    <input
                                                                        type="text"
                                                                        value={row[column.field] || ""}
                                                                        onChange={(event) => {
                                                                            const newValue = event.target.value;
                                                                            this.setState((prevState) => ({
                                                                                questionConfigData:
                                                                                    prevState.questionConfigData.map((r) =>
                                                                                        r.Id === row.Id
                                                                                            ? { ...r, [column.field]: newValue }
                                                                                            : r
                                                                                    ),
                                                                            }));
                                                                        }}
                                                                        style={{
                                                                            width: "100%",
                                                                            fontSize: "10px",
                                                                            padding: "4px",
                                                                            boxSizing: "border-box",
                                                                            border: "1px solid black",
                                                                        }}
                                                                    />
                                                                ) : column.field === "IsActive" ? (
                                                                    row[column.field] ? "Active" : "Inactive"
                                                                ) : column.field === "Action" ? (
                                                                    <>
                                                                        <div style={{ display: 'flex', gap: '10px' }}>
                                                                            <Edit fontSize='small' sx={{ cursor: "pointer" }} onClick={() => {
                                                                                this.setState({
                                                                                    addDialogData: {
                                                                                        isOpen: true,
                                                                                        row: row,
                                                                                        selectedLob: SelectedLob,
                                                                                        selectedQuestionConfig: row.QuestionID,
                                                                                        selectedBrokerId: SelectedBrokerId,
                                                                                        selectedCoverageSpec: row.CoverageSpecID
                                                                                    }
                                                                                });
                                                                            }} />
                                                                            {showDelete &&
                                                                                (<Delete fontSize='small' sx={{ cursor: "pointer" }} onClick={() => {
                                                                                    this.setState({
                                                                                        confirmationDialog: {
                                                                                            isOpen: true,
                                                                                            recordId: row?.LobQuestionID,
                                                                                            message: `Are you Sure you want to delete this record of Id: ${row?.LobQuestionID}?`,
                                                                                            activate: false,
                                                                                            isDelete: true
                                                                                        }
                                                                                    });
                                                                                }} />)}
                                                                        </div>
                                                                    </>
                                                                ) : (
                                                                    column.field === "Question"
                                                                        ? (row[column.field] || "").substring(0, 3)
                                                                        : row[column.field]
                                                                )}
                                                            </TableCell>
                                                        ))}
                                                    </TableRow>
                                                ))
                                            )}
                                        </TableBody>
                                    </Table>
                                </Box>
                            </TableContainer>
                        </Box>
                        {/* <TablePagination
                            component="div"
                            count={totalCount}
                            page={page}
                            onPageChange={this.handlePageChange}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={this.handleRowsPerPageChange}
                            rowsPerPageOptions={[10, 25, 50, 100, 200]}
                        /> */}
                    </Paper>
                </GridTable>

                <ConfirmationDialogComponent open={confirmationDialog.isOpen} message={confirmationDialog.message} onConfirm={() => { this.onConfirmationDialog() }} onClose={() => {
                    this.setState({
                        confirmationDialog: {
                            isOpen: false,
                            recordId: 0,
                            message: "",
                            activate: false,
                            isDelete: false
                        }
                    });
                }} />

                <Dialog open={addDialogData.isOpen} onClose={this.handleClose.bind(this)} fullWidth maxWidth="md">
                    <DialogTitle>
                        {addDialogData.row ? "Edit Question Config" : "Add New Question Config"}
                    </DialogTitle>
                    <DialogContent>
                        <Typography
                            variant="body2"
                            sx={{ mb: 0.5, mt: 2, fontWeight: 500 }}
                        >
                            Broker
                        </Typography>

                        <Autocomplete
                            options={brokerMaster}
                            getOptionLabel={(option) => option?.label || ''}
                            value={brokerMaster.find((e: any) => e.value === addDialogData.selectedBrokerId) || null}
                            onChange={(event, newValue) => {
                                this.setState({ addDialogData: { ...addDialogData, selectedBrokerId: newValue?.value || 0 } });
                            }}
                            disableClearable
                            disabled
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Select Broker..."
                                    size="medium"
                                    InputProps={{
                                        ...params.InputProps,
                                        style: { height: 25, fontSize: "11px" }
                                    }}
                                />
                            )}
                            fullWidth
                            slotProps={{ listbox: { sx: { fontSize: '11px' } } }}
                        />
                        <Typography
                            variant="body2"
                            sx={{
                                mb: 0.5,
                                mt: 2,
                                fontWeight: 500
                            }}
                        >
                            Lob
                        </Typography>
                        <Autocomplete
                            options={LobMaster}
                            getOptionLabel={(option) => option?.label || ''}
                            value={LobMaster.find((e: any) => e.value === addDialogData.selectedLob) || null}
                            onChange={(event, newValue) => {
                                this.setState({ addDialogData: { ...addDialogData, selectedLob: newValue?.value || 0 } });
                            }}
                            disableClearable
                            disabled
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Select Broker..."
                                    size="medium"
                                    InputProps={{
                                        ...params.InputProps,
                                        style: { height: 25, fontSize: "11px" }
                                    }}
                                />
                            )}
                            fullWidth
                            slotProps={{ listbox: { sx: { fontSize: '11px' } } }}
                        />
                        <Typography
                            variant="body2"
                            sx={{
                                mb: 0.5,
                                mt: 2,
                                fontWeight: 500
                            }}
                        >
                            Select Question
                        </Typography>
                        <Autocomplete
                            options={QuestionMaster}
                            getOptionLabel={(option) => option?.label || ''}
                            value={QuestionMaster.find((e: any) => e.value === addDialogData.selectedQuestionConfig) || null}
                            onChange={(event, newValue) => {
                                this.setState({ addDialogData: { ...addDialogData, selectedQuestionConfig: newValue?.value || 0 } });
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Select Question..."
                                    size="medium"
                                    InputProps={{
                                        ...params.InputProps,
                                        style: { height: 25, fontSize: "11px" }
                                    }}
                                />
                            )}
                            fullWidth
                            slotProps={{ listbox: { sx: { fontSize: '11px' } } }}
                        />
                        <Typography
                            variant="body2"
                            sx={{
                                mb: 0.5,
                                mt: 2,
                                fontWeight: 500
                            }}
                        >
                            Select Coverage
                        </Typography>
                        <Autocomplete
                            options={CoverageMaster}
                            getOptionLabel={(option) => option?.label || ''}
                            value={CoverageMaster.find((e: any) => e.value === addDialogData.selectedCoverageSpec) || null}
                            onChange={(event, newValue) => {
                                this.setState({
                                    addDialogData: {
                                        ...addDialogData,
                                        selectedCoverageSpec: newValue?.value || ""
                                    }
                                });
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    placeholder="Select Coverage..."
                                    size="medium"
                                    InputProps={{
                                        ...params.InputProps,
                                        style: { height: 25, fontSize: "11px" }
                                    }}
                                />
                            )}
                            fullWidth
                            slotProps={{ listbox: { sx: { fontSize: '11px' } } }}
                        />
                        {addDialogData.row &&
                            (<>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        mb: 0.5,
                                        mt: 2,
                                        fontWeight: 500
                                    }}
                                >
                                    Sorted Order
                                </Typography>
                                <TextField
                                    size="small"
                                    placeholder="Question Code"
                                    value={addDialogData.row.SortOrder}
                                    onChange={(e) => {
                                        const value = e.target.value;

                                        // Allow empty value or numbers from 1 to 99
                                        if (value === "" || (/^\d{1,2}$/.test(value) && Number(value) >= 1 && Number(value) <= 99)) {
                                            this.setState({
                                                addDialogData: {
                                                    ...addDialogData,
                                                    row: {
                                                        ...addDialogData.row,
                                                        SortOrder: +value,
                                                    },
                                                },
                                            });
                                        }
                                    }}
                                    sx={{
                                        "& .MuiInputBase-input::placeholder": {
                                            fontSize: "11px",
                                        },
                                        "& .MuiInputBase-input": {
                                            fontSize: "11px",
                                        },
                                        width: "100%",
                                    }}
                                />
                            </>)}
                    </DialogContent>
                    <DialogActions
                        sx={{
                            px: 3,
                            py: 2,
                            justifyContent: "flex-end",
                            gap: 1,
                        }}
                    >
                        <Button
                            onClick={this.handleClose.bind(this)}
                            sx={{
                                color: "#1976d2",
                                fontSize: "14px",
                                fontWeight: 500,
                                textTransform: "uppercase",
                                minWidth: 90,
                                "&:hover": {
                                    backgroundColor: "rgba(25,118,210,0.08)",
                                },
                            }}
                        >
                            Cancel
                        </Button>

                        <Button
                            variant="contained"
                            onClick={() => this.onSubmit()}
                            sx={{
                                minWidth: 120,
                                height: 40,
                                backgroundColor: "#1976d2",
                                color: "#fff",
                                fontSize: "14px",
                                fontWeight: 600,
                                textTransform: "uppercase",
                                borderRadius: "4px",
                                boxShadow: "0px 3px 5px rgba(0,0,0,0.25)",
                                "&:hover": {
                                    backgroundColor: "#1565c0",
                                    boxShadow: "0px 5px 10px rgba(0,0,0,0.3)",
                                },
                                "&.Mui-disabled": {
                                    backgroundColor: "#c7c7c7",
                                    color: "#ffffff",
                                },
                            }}
                        >
                            {addDialogData.row ? "Update" : "Create"}
                        </Button>
                    </DialogActions>
                </Dialog>
                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={3000}
                    onClose={this.handleCloseSnackbar}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                >
                    <Alert severity={snackbarSeverity} onClose={this.handleCloseSnackbar}>
                        {snackbarMessage}
                    </Alert>
                </Snackbar>
            </div>
        )
    }
}
